/**
 * Better Auth client configuration
 *
 * Initializes the auth client with React hooks for session management.
 * Points to the API server for authentication endpoints.
 *
 * Plugins:
 * - magicLinkClient: enables `authClient.signIn.magicLink(...)` for
 *   passwordless email authentication.
 *
 * @see apps/web/src/env.ts for VITE_API_URL documentation
 */
import { createAuthClient } from "better-auth/react";
import { emailOTPClient, magicLinkClient } from "better-auth/client/plugins";
import { API_URL } from "@/env";

/**
 * Better Auth client instance with React hooks
 *
 * Provides:
 * - signIn: Methods for various sign-in flows (social, magicLink)
 * - signOut: Session termination
 * - useSession: React hook for session state
 */
export const authClient = createAuthClient({
  baseURL: API_URL,
  plugins: [magicLinkClient(), emailOTPClient()],
});

// Export commonly used methods and hooks
export const { signIn, signOut, useSession } = authClient;
